module.exports = __webpack_public_path__ + "img/preview_stempel.98ad466b.png";